export default (value, separator = '.') => value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
